<workflows-layout [workflows]="workflows" (refreshList)="getWorkflowList()"
></workflows-layout>